import {
  alpha,
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme
} from '@mui/material';
import { COLORS } from '@/config/colors';

export const listItemButton: {
  defaultProps?: ComponentsProps['MuiListItemButton'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiListItemButton'];
  variants?: ComponentsVariants<Theme>['MuiListItemButton'];
} = {
  styleOverrides: {
    root({ theme, ownerState }) {
      return {
        color: ownerState.disabled ? 'white' : theme.palette.grey['500'],
        fontWeight: 500,
        ':hover': {
          background: alpha(COLORS.primary['500'], 0.2)
        },
        ':focus': {
          background: alpha(COLORS.primary['300'], 0.2)
        },
        '&.Mui-selected': {
          color: theme.palette.grey[50],
          background: COLORS.primary[500],

          '&:hover': {
            background: COLORS.primary[700]
          }
        }
      };
    }
  }
};
